import { lazy } from 'react'

export const DeactivateLicenseModalAsync = lazy(() =>
    import('./DeactivateLicenseModal').then(({ DeactivateLicenseModal }) => ({
        default: DeactivateLicenseModal,
    }))
)
